import {
  CheckCircleOutline,
  Clear,
  KeyboardArrowDown,
} from '@mui/icons-material';

import { Status } from '@/domain/external-invitation/entities/external-invitation.entity';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function getButtonStatusAndValidateData(
  status: Status,
  isValidated: boolean,
  isHover: boolean,
) {
  // hover => check validated
  if (isHover === true && isValidated === true) {
    // Annuler
    return {
      text: translate('InviteExternalToFill.invitations-list.cancel'),
      textColor: Colors.Pink,
      bgColor: Colors.Pink_012,
      icon: <Clear />,
    };
  }
  if (isHover === true && isValidated === false) {
    // Valider
    return {
      text: translate('InviteExternalToFill.invitations-list.validate'),
      textColor: ColorsRaw.basic.White,
      bgColor: ColorsRaw.main.Navy_Dark,
      icon: <CheckCircleOutline />,
    };
  }
  // not hover => check status and isValidated
  if (isHover === false && isValidated === true) {
    // Validé
    return {
      text: translate('InviteExternalToFill.invitations-list.validated'),
      textColor: Colors.Green,
      bgColor: Colors.Green_012,
      icon: <CheckCircleOutline />,
    };
  }
  if (isHover === false && status === 'IN_PROGRESS') {
    // En cours
    return {
      text: translate(
        'InviteExternalToFill.invitations-list.status-values.IN_PROGRESS',
      ),
      textColor: ColorsRaw.basic.Cream,
      bgColor: ColorsRaw.anthracite.Anthracite_4,
      icon: <KeyboardArrowDown />,
    };
  }
  if (isHover === false && status === 'SUBMITTED') {
    // Envoyé
    return {
      text: translate(
        'InviteExternalToFill.invitations-list.status-values.SUBMITTED',
      ),
      textColor: ColorsRaw.basic.Cream,
      bgColor: ColorsRaw.anthracite.Anthracite_4,
      icon: <KeyboardArrowDown />,
    };
  }
  return {};
}

const Colors = {
  Green: '#41D650',
  Green_012: '#41D6501F',
  Pink: '#B81C64',
  Pink_012: '#B81C641F',
};
